import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const mockInterceptor = createMockInterceptor(
  environment.mock,
  environment.API_URL
);

export function createMockInterceptor(
  mockEnabled: boolean,
  apiUrl: string
): HttpInterceptorFn {
  return (req, next) => {
    if (mockEnabled) {
      const mockReq = req.clone({
        url: `${apiUrl}/${req.url}.json`,
      });
      return next(mockReq);
    }

    return next(req);
  };
}
